import cookies from 'js-cookie'

export const getCookie = (name: any) => {
  return cookies.get(name)
}
export const setCookie = (name: any, value: any, expires = 1) => {
  return cookies.set(name, value, { expires })
}
export const removeCookie = (name: any) => {
  return cookies.remove(name)
}
